module.exports = __webpack_public_path__ + "kz.svg?51d935d5514904b8cd4a00ce757f26ac";